import { setTimeout } from "timers";

(function () {
    'use strict';
    var controllerId = 'accountcontroller';

    angular
        .module('app.controllers')
        .controller(controllerId, accountcontroller);

    accountcontroller.$inject = ['$scope', '$location', 'common', 'datacontext', '$translate', 'tmhDynamicLocale', '$state', '$rootScope', '$timeout', 'ngDialog'];

    function accountcontroller($scope, $location, common, datacontext, $translate, tmhDynamicLocale, $state, $rootScope, $timeout, ngDialog) {
        var vm = this;
        var oldRUT = null;
        vm.account = {
            Countries: [],
            States: [],
            Cities: [],
            CountryModel: null,
            StateModel: null,
            CityModel: null,
            RUTisValid: false,
            SectionSocioShow: false,
            BPName: null,
            BPNameNew: null,
            BPShortName:null,
        };

        vm.userAccountRequest = {
            Email: null,
            ReEmail: null,
            UserName: null,
            UserLastName: null,
            Phone: null,
            DocumentNumber: null,
            CompanyName: null,
            CompanyShortName: null,
            CompanyAddress: null,
            CompanyCountryId: null,
            CompanyStateId: null,
            CompanyCityId: null,
            CompanyPhone: null,
            CompanyEmail: null,
            IsCustomsAgent: null,
            IsNewBusinessPartner: false,
            languageId:2,
        };

        init();
        function init() {
            common.activateController().then(function (data) {
                window.grecaptcha.render('recaptcha', { 'sitekey': common.config.recaptchaSitekey});
                window.grecaptcha.reset();
            });
            getCountries();
            $('#txtEmail, #txtReEmail').bind('paste', function (e) {
                e.preventDefault();
            });
            $('#txtEmail, #txtReEmail').bind('copy', function (e) {
                e.preventDefault();
            });
        }

        function ClearCompanyInformation(){
            vm.account.BPShortName = null;
            vm.account.BPNameNew = null;
            vm.userAccountRequest.CompanyName  = null;
            vm.userAccountRequest.CompanyShortName = null;
            vm.userAccountRequest.CompanyAddress = null;
            vm.userAccountRequest.CompanyCountryId = null;
            vm.userAccountRequest.CompanyStateId = null;
            vm.userAccountRequest.CompanyCityId = null;
            vm.account.Cities = [];
            vm.account.States = [];
            vm.account.CountryModel = null;
            vm.account.StateModel = null;
            vm.account.CityModel = null;
        }

        vm.rutActivation = function(){
            if(vm.userAccountRequest.IsCustomsAgent == true){
                vm.account.SectionSocioShow = false;
                vm.userAccountRequest.DocumentNumber = null;
                vm.account.BPName = null;
                ClearCompanyInformation();
            }
        }

        vm.requestRegister = function () {
            vm.userAccountRequest.CompanyName = (vm.account.BPName || '') + (vm.account.BPNameNew || '');
            vm.userAccountRequest.CompanyCountryId = vm.account.CountryModel ? vm.account.CountryModel.CountryId : null;
            vm.userAccountRequest.CompanyStateId = vm.account.StateModel ? vm.account.StateModel.StateId : null;
            vm.userAccountRequest.CompanyCityId = vm.account.CityModel ? vm.account.CityModel.CityId : null;
            vm.userAccountRequest.IsNewBusinessPartner = vm.account.IsNewBusinessPartner;

            var validResult = vm.userAccountRequestIsValid(vm.userAccountRequest);

            if (!validResult.isValid) {
                toastr.error(validResult.message);
                return;
            }

            var inputRecaptcha = window.grecaptcha.getResponse();
            if (inputRecaptcha.length==0) {
                toastr.error($translate.instant('message.login.capcthaNotPass'));
                return;
            }

            datacontext.useraccountrequest.RequestRegister(vm.userAccountRequest).then(function (response) {
                if (response && response.Successful) {
                    toastr.info(response.Message);
                    $state.go('login');
                }
                else {
                    toastr.error(response.Message);
                }
            }, function (exception) {
                if (exception.status)
                    toastr.error(exception.info);
            });
        };

        vm.userAccountRequestIsValid = function (userAccountRequest) {
            var genericMessage = $translate.instant('views.createaccount.msgValidateGeneric');
            //IsCustomsAgent
            //Email
            if (!userAccountRequest.Email || !userAccountRequest.Email.trim() || !isValidEmail(userAccountRequest.Email.trim()))
                return { isValid: false, message: genericMessage + ' ' + $translate.instant('views.createaccount.email') };
            //ReEmail
            if (!userAccountRequest.ReEmail || !userAccountRequest.ReEmail.trim() || !isValidEmail(userAccountRequest.ReEmail.trim()))
                return { isValid: false, message: genericMessage + ' ' + $translate.instant('views.createaccount.reemail') };
            //Verify Email and ReEmail
            if (userAccountRequest.Email != userAccountRequest.ReEmail )
                return { isValid: false, message: $translate.instant('views.createaccount.msgValidateEmail') };
            //UserName
            if (!userAccountRequest.UserName || !userAccountRequest.UserName.trim())
                return { isValid: false, message: genericMessage + ' ' + $translate.instant('views.createaccount.name') };
            //UserLastName
            if (!userAccountRequest.UserLastName || !userAccountRequest.UserLastName.trim())
                return { isValid: false, message: genericMessage + ' ' + $translate.instant('views.createaccount.lastname')};
            //Phone
            if (!userAccountRequest.Phone || !userAccountRequest.Phone.trim())
                return { isValid: false, message: genericMessage + ' ' + $translate.instant('views.createaccount.phone')};
            //DocumentNumber
            if ((!userAccountRequest.DocumentNumber || !userAccountRequest.DocumentNumber.trim()) && vm.userAccountRequest.IsCustomsAgent != true)
                return { isValid: false, message: genericMessage + ' ' + $translate.instant('views.createaccount.bpcode')};
            //CompanyName
            if ((!userAccountRequest.CompanyName || !userAccountRequest.CompanyName.trim()) && vm.userAccountRequest.IsCustomsAgent != true)
                return { isValid: false, message: genericMessage + ' ' + $translate.instant('views.createaccount.bpname')};
            
           
                
            if (vm.account.SectionSocioShow)
            {
                //CompanyShortName
                if (!userAccountRequest.CompanyShortName || !userAccountRequest.CompanyShortName.trim())
                    return { isValid: false, message: genericMessage + ' ' + $translate.instant('views.createaccount.bpshortname')};
                    
                //CompanyAddress
                // if (!userAccountRequest.CompanyAddress || !userAccountRequest.CompanyAddress.trim())
                //     return { isValid: false, message: genericMessage + ' ' + $translate.instant('views.createaccount.bpaddress')};
                //CompanyCountryId
                //CompanyStateId
                //CompanyCityId
                //CompanyPhone
                // if (!userAccountRequest.CompanyPhone || !userAccountRequest.CompanyPhone.trim())
                //     return { isValid: false, message: genericMessage + ' ' + $translate.instant('views.createaccount.bptelephone')};
                //CompanyEmail
                // if (!userAccountRequest.CompanyEmail || !userAccountRequest.CompanyEmail.trim() || !isValidEmail(userAccountRequest.CompanyEmail.trim()))
                //     return { isValid: false, message: genericMessage + ' ' + $translate.instant('views.createaccount.bpemail')};
                
            }

            //userAccountRequest.
            return {isValid:true,message:null};
        };

        vm.CountriesChange = function () {
            getStatesByCountry(vm.account.CountryModel.CountryId)
        };

        vm.StatesChange = function () {
            if(vm.account.StateModel){
                getCitiesByState(vm.account.StateModel.StateId)
            }else{
                vm.account.Cities = [];
            }
        };

        vm.inputKeyPressRUTHandler = function (keyEvent) {
            if (keyEvent.which === 13) {
                rutValidate()
            }
        };

        vm.inputFocusOutRUTHandler = function (keyEvent) {
            if(oldRUT != vm.userAccountRequest.DocumentNumber){
                if (vm.userAccountRequest.DocumentNumber.length > 0) {
                    rutValidate()
                }
            }   
        };

        function rutValidate(){
            oldRUT = vm.userAccountRequest.DocumentNumber;
            ClearCompanyInformation();
            datacontext.useraccountrequest.RUTvalidate(vm.userAccountRequest.DocumentNumber).then(function (response) {
                if (response == null || response == '') {
                    vm.account.RUTisValid = false;
                    vm.account.SectionSocioShow = true;
                    vm.account.IsNewBusinessPartner = true;
                }
                else {
                    vm.account.RUTisValid = true;
                    vm.account.SectionSocioShow = false;
                    vm.account.IsNewBusinessPartner = false;
                    vm.account.BPName = response;
                }
            }, function (exception) {
                if (exception.status)
                    toastr.error(exception.info);
            });
        }

        function isValidEmail(mail) {
            return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(mail);
        }

        function getCountries() {
            return datacontext.useraccountrequest.getCountries().then(function (response) {
                if (response) {
                    vm.account.Countries = response;
                }
            }, function (exception) {
                if (exception.status)
                    toastr.error(exception.info);
            });
        };

        function getStatesByCountry(countryId) {
            return datacontext.useraccountrequest.getStatesByCountry(countryId).then(function (response) {
                if (response) {
                    vm.account.States = response;
                }
            }, function (exception) {
                if (exception.status)
                    toastr.error(exception.info);
            });
        };

        function getCitiesByState(stateId) {
            return datacontext.useraccountrequest.getCitiesByState(stateId).then(function (response) {
                if (response) {
                    vm.account.Cities = response;
                }
            }, function (exception) {
                if (exception.status)
                    toastr.error(exception.info);
            });
        };


    }
})();